<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Eventos",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Eventos",
                active: true
                }
            ],
            datoseventos:[],
            eventos:[],
            eventoseleccionada: [],                       //alumna seleccionada en el buscador
            eventoid_seleccion: [],                       //id alumna 
            eventoid_seleccion1: [],                       //id alumna 
            habilitar_boton: false,  
            editing: false,
            originalevento:'',
            tipos:[],
            subtipos:[],
            cursos: ['Primero Medio', 'Segundo Medio', 'Tercero Medio', 'Cuarto Medio', 'Egresado'],
            emailError:'',
            phoneerror:'',
            copiado:false,
            isLoading: false,
            colegios:[],
            todos_colegios:[],
            usuarios:[],
            subtiposfilter:[],
            estados:['Aprobado','Cerrado','Cancelado'],
            estado:''
        };
    },
    computed:{
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.eventoid_seleccion.correo_notificaciones);
        }
    },
    methods:{
        validateEmail() {
            if (this.eventoid_seleccion.correo_notificaciones && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.eventoid_seleccion.telefono_notificaciones.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.eventoid_seleccion.telefono_notificaciones = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.eventoid_seleccion.telefono_notificaciones.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        modificar_id(eventoseleccionada) {
            this.datoseventos.forEach(element => {
                if (element.nombre == eventoseleccionada) {
                    this.eventoid_seleccion = element.id;
                    //console.log(element.nombre); 
                    this.habilitar_boton = true
                }
            });
        },
        toggleEdit() {
            this.originalevento = { ...this.eventoid_seleccion };
            if (this.editing) {
                if(this.validacion){
                    this.isLoading=true;
                    this.originalevento.nombre_difusion = this.eventoid_seleccion.nombre_difusion;
                    this.originalevento.fecha_inicio = this.eventoid_seleccion.fecha_inicio;
                    this.originalevento.fecha_termino = this.eventoid_seleccion.fecha_termino;
                    this.originalevento.tipo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.tipo_codigo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.subtipo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.subtipo_codigo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.propietario = this.eventoid_seleccion.propietario.name;
                    this.originalevento.curso_multi = JSON.stringify(this.eventoid_seleccion.curso_multi);
                    this.originalevento.correo_notificaciones = this.eventoid_seleccion.correo_notificaciones;
                    this.originalevento.telefono_notificaciones = this.eventoid_seleccion.telefono_notificaciones;
                    this.originalevento.titulo_landing_inscripcion = this.eventoid_seleccion.titulo_landing_inscripcion;
                    this.originalevento.user_id = this.eventoid_seleccion.coordinador_evento.id;
                    this.originalevento.coordinador_evento = this.eventoid_seleccion.coordinador_evento.rut;
                    this.originalevento.coordinador = this.eventoid_seleccion.coordinador_evento.name;
                    this.originalevento.rbd_colegio = this.eventoid_seleccion.colegio_datos.rbd;
                    this.originalevento.colegio = this.eventoid_seleccion.colegio_datos.nombre;
                    this.originalevento.sede_asociada = this.eventoid_seleccion.propietario.sede;
                    this.originalevento.propietario_colegio = this.eventoid_seleccion.colegio_datos.propietario;
                    this.originalevento.estado_actividad = this.eventoid_seleccion.estado_actividad[0].nombre;
                    axios.post('/api/editar_evento',this.originalevento).then(res=>{
                        if(res.data.estado){
                            //this.sucursal=res.data.sucursal
                            //window.location.reload(); 
                            this.eventoid_seleccion1=res.data.evento
                            Swal.fire({
                                //position: "top-end",
                                icon: "success",
                                title: res.data.mensaje,
                                text: '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }else{
                            Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: res.data.mensaje,
                                text: '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                        this.isLoading=false
                    })
                }
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                this.consultarEvento();
            }
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        onSelectEvento(evento) {
            // console.log('Evento seleccionado:', evento);
            this.consultarEvento();
        },
        onEnterSelectEvento() {
            this.consultarEvento();
        },
        onSelectColegio(){
            this.eventoid_seleccion.colegio = this.eventoid_seleccion.colegio_datos.nombre;
            this.eventoid_seleccion.rbd_colegio = this.eventoid_seleccion.colegio_datos.rbd;
        },
        select1(){
            this.eventoid_seleccion1 = this.eventoseleccionada
            this.eventoid_seleccion1.tipo_nombre= this.tipos.find((us) => us.codigo == this.eventoid_seleccion1.tipo_codigo).nombre;
            this.eventoid_seleccion1.subtipo_nombre= this.subtipos.find((us) => us.codigo == this.eventoid_seleccion1.subtipo_codigo).nombre;
            if (this.eventoseleccionada.curso_multi!='') {
                this.eventoid_seleccion1.cursos = this.eventoseleccionada.curso_multi;
                this.eventoid_seleccion1.curso_multi = this.eventoseleccionada.curso_multi.split(";");
            }
            this.eventoid_seleccion.estado_actividad= this.estados_eventos.filter((us) => us.nombre==this.eventoid_seleccion.estado_actividad);
        },
        select(){
            this.eventoid_seleccion.colegio_datos= this.colegios.find((us) => us.rbd==this.eventoid_seleccion.rbd_colegio);
            this.eventoid_seleccion.tipo= this.tipos.find((us) => us.codigo == this.eventoid_seleccion.tipo);
            this.ver_subtipo();
            this.eventoid_seleccion.subtipo= this.subtipos.find((us) => us.codigo == this.eventoid_seleccion.subtipo);
            this.eventoid_seleccion.coordinador_evento= this.usuarios.filter((us) => us.name==this.eventoid_seleccion.coordinador_evento);
            this.eventoid_seleccion.propietario= this.usuarios.filter((us) => us.name==this.eventoid_seleccion.propietario);
        },
        consultarEvento() {
            const id = this.eventoseleccionada.codigo; // Id del evento seleccionado
            this.eventoid_seleccion = this.eventoseleccionada
            this.isLoading=true
            axios.get(`/api/get_evento_crm/${id}`).then(response => {
                if(response.data.estado){
                    //console.log(response.data.evento)
                    this.eventoid_seleccion=response.data.evento
                    this.eventoid_seleccion1=response.data.evento
                    console.log(this.eventoid_seleccion)
                    this.select1()
                    this.select()
                    this.eventoid_seleccion.curso_multi.endsWith(";") ? this.eventoid_seleccion.curso_multi=this.eventoid_seleccion.curso_multi.slice(0, -1) : '';
                    this.eventoid_seleccion.curso_multi=this.eventoid_seleccion.curso_multi.split(";")
                    //this.eventoid_seleccion.tipo=this.eventoid_seleccion.tipo[0]
                    Swal.fire({
                        icon: "success",
                        title: "Buscando evento..",
                        text: "La información del evento se ha actualizado correctamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    //this.format();
                    this.isLoading=false
                }else{
                    Swal.fire({
                        icon: "error",
                        title: "Sin datos del evento..",
                        text: "Evento no existe en CRM..",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    // console.log('Error al consultar')
                    console.log("No existen datos del evento en crm: "+id);
                    console.log(response.data.evento);
                    this.EventoNoExiste=true;
                    this.isLoading=false
                }
            });
        },
        ver_subtipo(){              
            this.subtiposfilter = this.subtipos.filter((subtipo) => subtipo.tipo_id==this.eventoid_seleccion.tipo.id);
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        ver_colegio(rbd){
            localStorage.setItem('rbd_colegio',rbd);
        },
        buscar_colegio(){
            localStorage.setItem("colegio", this.eventoid_seleccion.rbd_colegio);
            window.location.href = "/web/configuracion/colegios";
        },
        msgval(campo) {
            Swal.fire({
                icon: 'error',
                title: 'Campo Obligatorio',
                text: `Por favor, completa el campo "${campo}".`,
                confirmButtonText: 'Aceptar'
            });
        },
        validacion() {
            const campos = {
                nombre_difusion: 'Actividad',
                codigo: 'Código',
                fecha_inicio: 'Fecha Inicio',
                fecha_termino: 'Fecha Término',
                tipo: 'Tipo',
                subtipo: 'Subtipo',
                curso_multi: 'Curso',
                correo_notificaciones: 'Correo notificaciones',
                telefono_notificaciones: 'Teléfono notificaciones',
                nombre_difusion: 'Nombre para Difusión Digital',
                coordinador_evento: 'Coordinador evento',
            };
            for (let campo in campos) {
                if (!this.eventoid_seleccion[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            return true;//this.crear_evento();
        },
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        labelselect_usuarios ({ name }) {
            return `${name}`
        },
        labelselect_colegio ({ nombre , rbd}) {
            return `${rbd}-${nombre}`
        },
        eliminar(id){
            Swal.fire({
                title: '¿Estas seguro que deseas eliminar el evento?',
                text: "Esto no se podrá revertir",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#40afd8',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, estoy seguro',
                cancelButtonText: 'Cancelar',
                }).then((result) => {
                if (result.isConfirmed) {
                    let formData = new FormData();
                    formData.append('id', id);
                    axios.post('/api/eliminar_evento',formData).then(res=>{
                        if (res.data.estado) {
                            Swal.fire({
                                title: 'Eliminado',
                                text: "Evento eliminado",
                                icon: 'success',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            })
                        }else{
                            Swal.fire({
                                title: 'No se puede eliminar',
                                text: res.data.mensaje,
                                icon: 'warning',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            })
                        }
                        
                    });
                }
            });
        },
        cambio_estado(es){
            let formData = new FormData();
            formData.append('id', this.eventoid_seleccion1.id);
            formData.append('estado', es);
            axios.post('/api/cambio_estado',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Cambio de estado exitoso",
                        text: es,
                        timer: 5000,
                        showConfirmButton: false
                    });
                    this.eventoseleccionada = this.eventos.filter(us=>us.codigo==this.eventoid_seleccion1.codigo);
                    this.consultarEvento();
                }else{
                    Swal.fire({
                        icon: "error",
                        title: "No se cambió el estado",
                        text: '',
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        },
        correo_agradecimiento(){
            axios.get('/api/envio_agradecimiento').then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Envio de correo exitoso",
                        text: '',
                        timer: 5000,
                        showConfirmButton: false
                    });
                }  
            });
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
        axios.get('/api/get_colegios').then(res=>{
            this.colegios=res.data.colegios;
            this.todos_colegios=res.data.colegios;
        });
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
    },
    created(){
        this.isLoading=true;
        axios.get('/api/get_eventos').then(res=>{
            this.estados_eventos = res.data.estados_eventos;
            this.datoseventos=res.data.eventos
            this.eventos=res.data.eventos
            if (localStorage.getItem("evento_codigo")) {
                const evento_codigo = localStorage.getItem("evento_codigo");
                localStorage.removeItem("evento_codigo");
                this.eventoseleccionada=this.eventos.find(ev=>ev.codigo==evento_codigo)
                this.consultarEvento();
            }
            this.isLoading=false;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="offset-md-2 col-md-8">
                                <div class="row">
                                    <div class="col-md-10">
                                        <b-form-group label="Buscar Evento:">
                                            <multiselect
                                                v-model="eventoseleccionada"
                                                :options="eventos"
                                                :custom-label="labelEvento"
                                                placeholder="Evento"
                                                selectLabel="Seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Remover"
                                                track-by="codigo"
                                                :searchable="true"
                                                :filterable="true"
                                                @select="onSelectEvento"
                                                >
                                                
                                                <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!-- <div class="col-md-2">
                                        <b-button variant="primary" block @click="consultarEvento">Buscar</b-button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" >
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" >
                                <div class="card mt-3 shadow-sm border-light">
                                    <div class="card-body">
                                        <div class="row" v-if="eventoid_seleccion!=''">
                                            <div class="col-md-12">
                                                <b-button class="float-right" variant="primary" @click="buscar_colegio()">Volver Colegio</b-button>
                                            </div>
                                            <div class="col-md-12">
                                                <h1 class="text-primary mb-4">Evento: {{ editing ?  eventoid_seleccion.nombre_difusion : eventoid_seleccion.nombre_difusion }}</h1>
                                                <h2 class="text-primary">Colegio: {{ editing ?  eventoid_seleccion.colegio : eventoid_seleccion.colegio }}</h2>
                                                <h3 class="text-primary">RBD: {{ editing ?  eventoid_seleccion.rbd_colegio : eventoid_seleccion.rbd_colegio }}</h3>
                                                <div class="row" v-if="editing">
                                                    <div class="col-md-6">
                                                        <div class="form-group row" >
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Colegio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect 
                                                                    v-model="eventoid_seleccion.colegio_datos"
                                                                    :options="colegios" 
                                                                    placeholder="Seleccionar colegio" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_colegio"
                                                                    @select="onSelectColegio">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="pais" v-model="eventoid_seleccion.colegio" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Actividad:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="pais" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Código:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.codigo" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <!-- <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Área:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.area" class="form-control border-primary">
                                                            </div>
                                                        </div> -->
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha inicio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="direccion" v-model="eventoid_seleccion.fecha_inicio" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha de término:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="ciudad" v-model="eventoid_seleccion.fecha_termino" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Tipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.tipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.tipo"
                                                                    :options="tipos.filter(t => t.codigo != null)" 
                                                                    placeholder="Seleccionar tipo" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" 
                                                                    @select="ver_subtipo()">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.tipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar tipo</option>
                                                                    <option v-for="tipo in tipos.filter(t => t.codigo != null)" :key="tipo.codigo" :value="tipo.codigo">
                                                                        {{ tipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Subtipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.subtipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.subtipo"
                                                                    :options="subtiposfilter" 
                                                                    placeholder="Seleccionar subtipo" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.subtipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar subtipo</option>
                                                                    <option v-for="subtipo in subtipos.filter(sub=>sub.tipo_codigo==eventoid_seleccion.tipo)" :key="subtipo.codigo" :value="subtipo.codigo">
                                                                        {{ subtipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Curso:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.curso_multi"
                                                                    :options="cursos" 
                                                                    :close-on-select="false"
                                                                    placeholder="Seleccionar curso" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :multiple="true"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="telefono" v-model="eventoid_seleccion.curso" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Notificaciones:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.correo_notificaciones" class="form-control border-primary" @blur="validateEmail">
                                                                <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Teléfono Notificaciones:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.telefono_notificaciones" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="estado"> Estado:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="estado" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect v-model="eventoid_seleccion.estado_actividad"
                                                                    :options="estados_eventos" 
                                                                    placeholder="Seleccionar estado" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    id="estado"
                                                                    v-model="eventoid_seleccion.estado_actividad"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar estado</option>
                                                                    <option v-for="estado in estados_eventos" :key="estado.id" :value="estado.codigo">
                                                                        {{ estado.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Nombre para Difusión Digital:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Coordinador evento:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.coordinador_evento"
                                                                    :options="usuarios" 
                                                                    placeholder="Seleccionar usuario" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_usuarios"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="email" id="email" v-model="eventoid_seleccion.coordinador_evento" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email"> Propietario:</label>
                                                            <multiselect
                                                                v-model="eventoid_seleccion.propietario"
                                                                :options="usuarios" 
                                                                placeholder="Seleccionar usuario" 
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                :custom-label="labelselect_usuarios"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                            <!-- <input type="email" id="email" v-model="eventoid_seleccion.propietario" class="form-control border-primary"> -->
                                                        </div>
                                                    </div>
                                                    <div class="offset-md-9 col-md-3 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar.' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col-md-6" >
                                                        <b-button variant="primary" @click="correo_agradecimiento" v-if="false"><i class="bx bx-send font-size-14"></i> Enviar agradecimiento</b-button>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mt-3 float-right">
                                                            <b-button v-if="editing" @click="cancelEdit" variant="primary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </b-button>
                                                            <b-button @click="toggleEdit" variant="primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar..' }}
                                                            </b-button>
                                                            <b-button variant="danger" @click="eliminar(eventoid_seleccion1.id)" v-if="user.id=='6' || user.id=='1'"><i class="bx bx-trash"></i></b-button>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="offset-md-6 col-md-6 mb-2">
                                                        <div class="mt-3 float-right">
                                                            <label for="">Estado:</label>
                                                            <multiselect
                                                                v-model="estado"
                                                                :options="estados" 
                                                                placeholder="Selecciona estado" 
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                @select="cambio_estado"
                                                                :close-on-select="true"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>Actividad:</strong> {{ eventoid_seleccion1.nombre_difusion }}</p>
                                                        <p class="font-size-16"><strong>Código:</strong> {{ eventoid_seleccion1.codigo }}</p>
                                                        <!-- <p class="font-size-16"><strong>Área:</strong> {{ eventoid_seleccion.area }}</p> -->
                                                        <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ eventoid_seleccion1.fecha_inicio }}</p><!--con hora -->
                                                        <p class="font-size-16"><strong>Fecha de término:</strong> {{ eventoid_seleccion1.fecha_termino }}</p>
                                                        <p class="font-size-16"><strong>Tipo:</strong> {{ eventoid_seleccion1.tipo_nombre}}</p>
                                                        <p class="font-size-16"><strong>Subtipo:</strong> {{ eventoid_seleccion1.subtipo_nombre }}</p>
                                                        <p class="font-size-16"><strong>Curso:</strong>
                                                            {{ eventoid_seleccion1.cursos}}
                                                        </p>
                                                        <p class="font-size-16"><strong>Correo Notificaciones:</strong> {{ eventoid_seleccion1.correo_notificaciones }}</p>
                                                        <p class="font-size-16"><strong>Teléfono Notificaciones:</strong> {{ eventoid_seleccion1.telefono_notificaciones }}</p>
                                                        <p class="font-size-16 d-flex align-items-center" @click="ver_colegio(eventoid_seleccion1.rbd_colegio)" style="cursor: pointer;">
                                                            <strong>RBD:</strong> {{ eventoid_seleccion1.rbd_colegio }} 
                                                            <i class="bx bx-link ml-2"></i>
                                                        </p>
                                                        <p class="font-size-16"><strong>Colegio:</strong> {{ eventoid_seleccion1.colegio }}</p>
                                                        <p class="font-size-16">
                                                            <strong>Landing Asistencia:</strong>
                                                            {{ eventoid_seleccion1.landing_asistencia }}
                                                            <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_asistencia)" v-if="eventoid_seleccion1.landing_asistencia!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>Nombre para Difusión Digital:</strong> {{ eventoid_seleccion1.nombre_difusion }}</p>
                                                        <p class="font-size-16"><strong>Sede Asociada:</strong> {{ eventoid_seleccion1.sede_asociada }}</p>
                                                        <p class="font-size-16"><strong>Cantidad Inscripciones:</strong> {{ eventoid_seleccion1.cantidad_inscripciones }}</p>
                                                        <p class="font-size-16"><strong>Nº Asistentes:</strong> {{ eventoid_seleccion1.num_asistentes }}</p>
                                                        <p class="font-size-16"><strong>Propietario:</strong> {{ eventoid_seleccion1.propietario }}</p>
                                                        <p class="font-size-16"><strong>Estado de la actividad:</strong> {{ eventoid_seleccion1.estado_actividad }}</p>
                                                        <p class="font-size-16"><strong>Tipo Landing:</strong> {{ eventoid_seleccion1.landing }}</p>
                                                        <p class="font-size-16"><strong>Propietario Colegio:</strong> {{ eventoid_seleccion1.propietario_colegio }}</p>
                                                        <p class="font-size-16"><strong>Coordinador Evento:</strong> {{ eventoid_seleccion1.coordinador_evento!=''?eventoid_seleccion1.coordinador_evento :''}}</p>
                                                        <p class="font-size-16"><strong>Fecha Creación:</strong> {{ eventoid_seleccion1.fecha_creacion }}</p>
                                                        <p class="font-size-16">
                                                            <strong>Landing Inscripción:</strong>
                                                            {{ eventoid_seleccion1.landing_inscripcion }}
                                                            <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_inscripcion)" v-if="eventoid_seleccion1.landing_inscripcion!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>